import { makeStyles } from 'tss-react/mui';

export const useAvatarStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: Number(theme.shape.borderRadius) / 2,

    color: theme.palette.accent.contrastText,
    '& svg': {
      width: '60%',
      height: '60%',
    },
  },
}));
